export const CouponType = {
  "DEFAULT": 0,
  "CREDIT": 1,
  "VOUCHER": 2,
  "REFERRAL": 3,
  "LOYALTY": 4,
  "FIRST_TIME": 5
}